import { render, staticRenderFns } from "./AmeliBanner.vue?vue&type=template&id=6f6edfd4&scoped=true&"
import script from "./AmeliBanner.vue?vue&type=script&lang=ts&"
export * from "./AmeliBanner.vue?vue&type=script&lang=ts&"
import style0 from "./AmeliBanner.vue?vue&type=style&index=0&id=6f6edfd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6edfd4",
  null
  
)

export default component.exports